import {
  useCreateProductSale,
  useGetProductSale,
} from 'api-hooks/product/sales';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductSaleForm from './components/form';
import { ProductSaleFormType } from './components/form-type';

export type ProductSaleViewParams = {
  id: string;
  defaultValues?: ProductSaleFormType;
};

export default function ProductSaleView(
  props: NavigationProps<NavigationRoutes.ProductSalesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetProductSale({
    id,
  });
  const { mutateAsync, error: errorMutate } = useCreateProductSale();

  const productSale = data?.data;

  const onResolve = useApprovalableEdit('product-sales');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ProductSaleForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            productSale={productSale}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
